<template>
  <div>
    <Form ref="form" :model="form" :rules="rule" :label-width="120" label-position="left">
      <FormItem :label="$t('name.user.type')" prop="username">
        <RadioGroup v-model="form.type">
          <template v-for="(item, key) in $t('name.user.type_text')">
            <Radio :label="key" :key="key">{{ item }}</Radio>
          </template>
        </RadioGroup>
      </FormItem>
      <FormItem :label="formName" prop="name">
        <Input size="large" type="text" v-model="form.name" />
      </FormItem>
      <FormItem :label="formPhone" prop="phone">
        <Input size="large" type="text" v-model="form.phone" />
      </FormItem>
      <FormItem :label="formEmail" prop="email">
        <Input size="large" type="text" v-model="form.email" />
      </FormItem>
      <FormItem :label="$t('name.user.username')" prop="username">
        <Input size="large" type="text" v-model="form.username" />
      </FormItem>
      <FormItem :label="$t('name.user.password')" prop="password">
        <Input size="large" type="password" v-model="form.password" />
      </FormItem>
    </Form>
    <Button size="large" type="primary" :loading="loading" @click="submit" long>{{ $t('name.register.submit') }}</Button>
    <a class="scoped-reg" @click="onClick">{{ $t('name.register.back') }}</a>
  </div>
</template>

<script>
import { register } from '@/api/auth'

export default {
  computed: {
    formName() {
      return this.$t('name.user.type_data')[this.form.type].name
    },
    formPhone() {
      return this.$t('name.user.type_data')[this.form.type].phone
    },
    formEmail() {
      return this.$t('name.user.type_data')[this.form.type].email
    }
  },
  data () {
    return {
      loading: false,
      form: {
        username: '',
        password: '',
        name: '',
        type: 0,
        phone: '',
        email: ''
      },
      rule: {
        username: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        password: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        name: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: ' ', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submit () {
      // 登陆
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          register(this.form).then(res => {
            this.$Message.success(this.$t('message.' + res.message))
            this.$emit('click')
          }).catch(error => {
            this.loading = false
            this.$Message.error(this.$t('message.' + error.message))
          })
        }
      })
    },
    onClick() {
      this.$emit('click')
    }
  }
}
</script>
<style lang="less" scoped>
  .scoped-reg {
    margin-top: 25px;
    text-align: right;
    display: block;
  }
</style>